import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { ErrorBoundary } from "@/components/ErrorBoundary";

const _u = new URL(window.location.href);
if (_u.searchParams.has("v")) { _u.searchParams.delete("v"); window.history.replaceState(null, "", _u.pathname + _u.search + _u.hash); }

window.addEventListener("beforeinstallprompt", (e) => {
  e.preventDefault();
  window.__installPrompt = e;
  window.dispatchEvent(new Event("faunny-install-ready"));
});
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => { navigator.serviceWorker.register("/service-worker.js").catch(() => {}); });
}

// Google Translate cambia nodos de texto; evita que React falle al actualizar esos nodos.
if (typeof Node === "function" && Node.prototype) {
  const remove = Node.prototype.removeChild;
  Node.prototype.removeChild = function (child) { return child.parentNode !== this ? child : remove.call(this, child); };
  const insert = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function (node, ref) { return ref && ref.parentNode !== this ? node : insert.call(this, node, ref); };
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </QueryClientProvider>
  </React.StrictMode>,
);
